import { DownloadOutlined, EyeOutlined } from '@ant-design/icons';
import { getGetFrontRichiesteIdPreventiviIdDownloadQueryOptions } from '@framework/api-client';
import { getNetworkErrorMessage } from '@framework/auth';
import {
  useAuthDownload,
  useHasDocumentsInlineViewer,
} from '@framework/common-web';
import { useTranslation } from '@framework/i18n';
import { Button, message } from 'antd';
import React from 'react';
import { useTheme } from 'styled-components';

export interface IQuoteDownloadButtonProps {
  submissionId: string;
  quoteId: string;
}

/**
 * Pulsante azione "Scarica" per il download di un preventivo.
 */
export function QuoteDownloadButton(props: IQuoteDownloadButtonProps) {
  const { submissionId, quoteId } = props;

  const { t } = useTranslation();
  const hasInlineViewer = useHasDocumentsInlineViewer();
  const theme = useTheme();

  const { download, isFetching } = useAuthDownload(
    getGetFrontRichiesteIdPreventiviIdDownloadQueryOptions,
    [submissionId, quoteId],
    {
      onError: e => {
        console.error(`[QuoteDownloadButton] Impossibile scaricare il preventivo`, { e }); // prettier-ignore
        message.error(getNetworkErrorMessage(e, t('quote-table.errore-in-download-file', 'Si è verificato un problema durante il download del file'))); // prettier-ignore
      },
      showInlineViewer: hasInlineViewer,
    },
  );

  return (
    <Button
      icon={
        !hasInlineViewer ? (
          <DownloadOutlined
            aria-label={t(
              'quote-table.azioni.button.aria-label.scarica-preventivo',
              'Scarica Preventivo',
            )}
          />
        ) : (
          <EyeOutlined aria-label={`${theme.viewPdfLabel} Preventivo`} />
        )
      }
      onClick={() => {
        download();
      }}
      loading={isFetching}
    />
  );
}
